import { getAuthState } from '../hooks/useAuth';

let auth = getAuthState()
export const resumoEmpresaGpt = async (Empresa: object, cnae_desc: string): Promise<object> => { 
    try {

            auth = getAuthState()
            const payload = { ...Empresa, cnae_desc };
            const response = await fetch('https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/resumoGpt', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': auth.idToken,
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            return JSON.parse(data.body);
        } catch (error) {
            console.error('Error fetching files:', error);
            return [];
        }
};